<template>
  <SmartFeed
    :source="usePublishedStoryFeedStore"
    :default-feed-layout="getOptionValue(SmartFeedLayout)"
    :default-entity-size="getOptionValue(SmartFeedCardLayout)"
    :edit-mode="editMode"
  >
    <template #empty-state>
      <iStyledCard width="fill">
        <template #title>
          <iSpace :height="10" />
          <iSubHeading variant="subtle" font-size="large" align="center">
            {{ getOptionValue(EmptyStateText) }}
          </iSubHeading>
        </template>
      </iStyledCard>
    </template>
  </SmartFeed>
</template>

<script>
import SmartFeed from "SmartFeed/components/SmartFeedV2.vue";
import { usePublishedStoryFeedStore } from "SmartFeed/stores/feed/published-story-feed-store";
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import { SmartFeedElementMixin } from "%/dynamic-component-editor/mixins/smart-feed-element-mixin";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import EmptyStateText from "%/dynamic-component-editor/options/empty-state-text";

export default {
  name: "StoriesUserPublished",
  components: {
    SmartFeed,
  },
  mixins: [
    DynamicElementMixin,
    SmartFeedElementMixin,
  ],
  elementPanelSettings: {
    displayName: "Stories User Published",
    displayIcon: "feed",
    elementGroup: "publishedStoriesElements",
    elementType: "element",
  },
  deprecated: true,
  options: [
    new LayoutWidth({
      "default": "fill",
      "hover": "fill",
    }, true),
    new EmptyStateText({ "default": "User has not published any stories yet." }),
  ],
  methods: {
    usePublishedStoryFeedStore,
  },
};
</script>

<style scoped lang="scss">
</style>
